const AD_SIZES = {
  leaderboard: { w: "w-full",  h: "h-[90px]",   label: "728 × 90",  desc: "Leaderboard" },
  rectangle:   { w: "w-full max-w-[300px]", h: "h-[250px]", label: "300 × 250", desc: "Medium Rectangle" },
  skyscraper:  { w: "w-full",  h: "h-[600px]",  label: "160 × 600", desc: "Skyscraper" },
  banner:      { w: "w-full",  h: "h-[50px]",   label: "320 × 50",  desc: "Mobile Banner" },
};

/**
 * AdBanner — drop-in ad placeholder.
 * Replace inner content with your actual ad code (Google AdSense, etc.)
 */
const AdBanner = ({ size = "leaderboard", className = "" }) => {
  const s = AD_SIZES[size] || AD_SIZES.leaderboard;
  return (
    <div
      data-testid={`ad-banner-${size}`}
      className={`${s.w} ${s.h} ${className} flex flex-col items-center justify-center border border-dashed border-zinc-200 rounded-xl bg-zinc-50 select-none overflow-hidden`}
    >
      {/* ── Replace with your ad code (AdSense, etc.) ── */}
      <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-300">{s.desc}</span>
      <span className="text-[10px] text-zinc-200 mt-0.5">{s.label}</span>
    </div>
  );
};

export default AdBanner;
